import api from '../token';

export const AlterVeiculo = async (dados) => {
  try {
    const response = await api.post('/alterVeiculo', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};





